import { Badge as BadgeANTD, BadgeProps } from 'antd';

export const Badge = (props: BadgeProps) => {
  return <BadgeANTD {...props} />;
};
